import { createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { RootState } from "./index";

const sensitiveDataTransform = createTransform(
  (inboundState: any, key) => {
    if (key === "Login") {
      return {
        ...inboundState,
        isLoading: false,
        error: "",
      };
    }
    return inboundState;
  },
  (outboundState) => outboundState
);

const persistConfig = {
  key: "dav-online-root",
  version: 1,
  storage,
  whitelist: [
    "Customers",
    "Products",
    "PaymentMethods",
    "PaymentForms",
    "Orders",
    "Login",
    "Layout",
  ] as Array<keyof RootState>,
  transforms: [sensitiveDataTransform],
  timeout: 10000,
};

export default persistConfig;
